const stateApp = "redux"; //value = redux or context to change the state management of the app
const designApp = "v1"; //la version du design de l'app for now we have v0:default v1, v2
const date = new Date();
const nameApp = "UMVAMarket";
const nameAppLong = "UMVAMarket";
const welcomeMessage = "Se connecter";
const footer = `© UMVA Market - ${date.getFullYear()}. Tous droits réservés`;

export default {
  stateApp,
  designApp,
  nameApp,
  nameAppLong,
  welcomeMessage,
  footer,
};
